module.exports = __webpack_public_path__ + "img/smallbill.62ccad71.png";